import React from 'react';
import PropTypes from 'prop-types'
import { Col } from 'react-bootstrap';

export default function InfoBoard({title, body}) {
  return (
    <>
      {
        title && 
          <Col className="rounded-top bg-color-primary py-2">
            <span className="text-3 font-weight-bolder">{title}</span>
          </Col>
      }
      {
        body &&
          <Col className="rounded-bottom bg-color-secondary py-2 mt-1">
            <span className="text-3">{body}</span>
          </Col>
      }
    </>
  );
}

InfoBoard.propTypes = {
  title: PropTypes.node,
  body: PropTypes.node,
}